import React from 'react';
import ActionLog from '../components/ActionLog';
import Pageheader from '../utils/headerHelment';

const ActionLogView = () => {
    return (
        <>
            <Pageheader title="LENS - Action Log" />
            <ActionLog />
        </>
    );
};

export default ActionLogView;
